define((require) => {
    "use strict";

    const StyleableMixin     = require("shared/ui/experience/widgets/StyleableMixin");
    const AbstractWidgetView = require("shared/ui/experience/widgets/AbstractWidgetView");

    /**
     * The view rendering a shape widget.
     *
     * @class ShapeWidgetView
     * @constructor
     *
     * @cfg {ShapeWidgetModel} model The model of the shape widget being rendered.
     */
    return AbstractWidgetView.extend("ShapeWidget", {

        mixin: StyleableMixin

    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/shapeWidget/ShapeWidgetView.js